import { Country } from '../domain/country.type'
import CountryEnum from '../domain/country.enum'

/**
 * Helper to provide fallback between dynamic countries and hardcoded enum
 * Ensures backward compatibility when country management feature is disabled
 */
export class CountryHelper {
  /**
   * Convert legacy enum to Country array (fallback when feature is disabled)
   */
  static enumToCountries(): Country[] {
    const enumValues = Object.values(CountryEnum)
    const codeMap: Record<string, string> = {
      'France': 'FR',
      'Italie': 'IT',
      'Luxembourg': 'LU',
      'Espagne': 'ES',
      'Principauté de Monaco': 'MC'
    }

    return enumValues.map((name, index) => ({
      id: `legacy-${index}`,
      code: codeMap[name] || name.substring(0, 2).toUpperCase(),
      name: name,
      flagIconPath: `/icons/flags/${codeMap[name]?.toLowerCase() || 'default'}.svg`,
      active: true,
    }))
  }

  /**
   * Get country name from code (supports both new and legacy)
   */
  static getCountryName(code: string): string {
    const nameMap: Record<string, string> = {
      'FR': 'France',
      'IT': 'Italie',
      'LU': 'Luxembourg',
      'ES': 'Espagne',
      'MC': 'Principauté de Monaco'
    }
    return nameMap[code] || code
  }

  /**
   * Get country code from name (supports both new and legacy)
   */
  static getCountryCode(name: string): string {
    const codeMap: Record<string, string> = {
      'France': 'FR',
      'Italie': 'IT',
      'Luxembourg': 'LU',
      'Espagne': 'ES',
      'Principauté de Monaco': 'MC'
    }
    return codeMap[name] || name
  }

  /**
   * Check if a country name/code is valid
   */
  static isValidCountry(nameOrCode: string): boolean {
    const validNames = Object.values(CountryEnum)
    const validCodes = ['FR', 'IT', 'LU', 'ES', 'MC']
    return validNames.includes(nameOrCode as CountryEnum) || validCodes.includes(nameOrCode)
  }
}

export default CountryHelper
